// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.35.0
// source: notifications.proto
/* eslint-disable */
import { BinaryReader, BinaryWriter } from '@bufbuild/protobuf/wire'

import {
  AlgoStatus,
  algoStatusFromJSON,
  algoStatusToJSON,
  AlgoType,
  algoTypeFromJSON,
  algoTypeToJSON,
} from './algo'
import { AccountStatus, accountStatusFromJSON, accountStatusToJSON } from './common/account'
import {
  Denomination,
  denominationFromJSON,
  denominationToJSON,
  OrderSide,
  orderSideFromJSON,
  orderSideToJSON,
  OrderStatus,
  orderStatusFromJSON,
  orderStatusToJSON,
} from './common/trading'
import {
  Exchange,
  exchangeFromJSON,
  exchangeToJSON,
  TradeVenue,
  tradeVenueFromJSON,
  tradeVenueToJSON,
} from './common/types'
import { NewOrderParams } from './execution'

export const protobufPackage = 'notifications'

export enum VenueRateLimitSource {
  VENUE_RATE_LIMIT_SOURCE_UNSPECIFIED = 0,
  VENUE_RATE_LIMIT_SOURCE_INTROSPECTED = 1,
  VENUE_RATE_LIMIT_SOURCE_CONFIGURED = 2,
  VENUE_RATE_LIMIT_SOURCE_UNKNOWN = 3,
  UNRECOGNIZED = -1,
}

export function venueRateLimitSourceFromJSON(object: any): VenueRateLimitSource {
  switch (object) {
    case 0:
    case 'VENUE_RATE_LIMIT_SOURCE_UNSPECIFIED':
      return VenueRateLimitSource.VENUE_RATE_LIMIT_SOURCE_UNSPECIFIED
    case 1:
    case 'VENUE_RATE_LIMIT_SOURCE_INTROSPECTED':
      return VenueRateLimitSource.VENUE_RATE_LIMIT_SOURCE_INTROSPECTED
    case 2:
    case 'VENUE_RATE_LIMIT_SOURCE_CONFIGURED':
      return VenueRateLimitSource.VENUE_RATE_LIMIT_SOURCE_CONFIGURED
    case 3:
    case 'VENUE_RATE_LIMIT_SOURCE_UNKNOWN':
      return VenueRateLimitSource.VENUE_RATE_LIMIT_SOURCE_UNKNOWN
    case -1:
    case 'UNRECOGNIZED':
    default:
      return VenueRateLimitSource.UNRECOGNIZED
  }
}

export function venueRateLimitSourceToJSON(object: VenueRateLimitSource): string {
  switch (object) {
    case VenueRateLimitSource.VENUE_RATE_LIMIT_SOURCE_UNSPECIFIED:
      return 'VENUE_RATE_LIMIT_SOURCE_UNSPECIFIED'
    case VenueRateLimitSource.VENUE_RATE_LIMIT_SOURCE_INTROSPECTED:
      return 'VENUE_RATE_LIMIT_SOURCE_INTROSPECTED'
    case VenueRateLimitSource.VENUE_RATE_LIMIT_SOURCE_CONFIGURED:
      return 'VENUE_RATE_LIMIT_SOURCE_CONFIGURED'
    case VenueRateLimitSource.VENUE_RATE_LIMIT_SOURCE_UNKNOWN:
      return 'VENUE_RATE_LIMIT_SOURCE_UNKNOWN'
    case VenueRateLimitSource.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** ENG-1063 D16: which venue scope the budget is defined on. */
export enum VenueRateLimitScope {
  VENUE_RATE_LIMIT_SCOPE_UNSPECIFIED = 0,
  VENUE_RATE_LIMIT_SCOPE_WALLET = 1,
  VENUE_RATE_LIMIT_SCOPE_ACCOUNT = 2,
  VENUE_RATE_LIMIT_SCOPE_UID = 3,
  UNRECOGNIZED = -1,
}

export function venueRateLimitScopeFromJSON(object: any): VenueRateLimitScope {
  switch (object) {
    case 0:
    case 'VENUE_RATE_LIMIT_SCOPE_UNSPECIFIED':
      return VenueRateLimitScope.VENUE_RATE_LIMIT_SCOPE_UNSPECIFIED
    case 1:
    case 'VENUE_RATE_LIMIT_SCOPE_WALLET':
      return VenueRateLimitScope.VENUE_RATE_LIMIT_SCOPE_WALLET
    case 2:
    case 'VENUE_RATE_LIMIT_SCOPE_ACCOUNT':
      return VenueRateLimitScope.VENUE_RATE_LIMIT_SCOPE_ACCOUNT
    case 3:
    case 'VENUE_RATE_LIMIT_SCOPE_UID':
      return VenueRateLimitScope.VENUE_RATE_LIMIT_SCOPE_UID
    case -1:
    case 'UNRECOGNIZED':
    default:
      return VenueRateLimitScope.UNRECOGNIZED
  }
}

export function venueRateLimitScopeToJSON(object: VenueRateLimitScope): string {
  switch (object) {
    case VenueRateLimitScope.VENUE_RATE_LIMIT_SCOPE_UNSPECIFIED:
      return 'VENUE_RATE_LIMIT_SCOPE_UNSPECIFIED'
    case VenueRateLimitScope.VENUE_RATE_LIMIT_SCOPE_WALLET:
      return 'VENUE_RATE_LIMIT_SCOPE_WALLET'
    case VenueRateLimitScope.VENUE_RATE_LIMIT_SCOPE_ACCOUNT:
      return 'VENUE_RATE_LIMIT_SCOPE_ACCOUNT'
    case VenueRateLimitScope.VENUE_RATE_LIMIT_SCOPE_UID:
      return 'VENUE_RATE_LIMIT_SCOPE_UID'
    case VenueRateLimitScope.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum DeadmanArmRefusedReason {
  DEADMAN_ARM_REFUSED_REASON_UNSPECIFIED = 0,
  DEADMAN_ARM_REFUSED_REASON_OPEN_ORDER_CAP = 1,
  DEADMAN_ARM_REFUSED_REASON_STALE_GENERATION = 2,
  DEADMAN_ARM_REFUSED_REASON_RESERVATION_STORE_UNAVAILABLE = 3,
  UNRECOGNIZED = -1,
}

export function deadmanArmRefusedReasonFromJSON(object: any): DeadmanArmRefusedReason {
  switch (object) {
    case 0:
    case 'DEADMAN_ARM_REFUSED_REASON_UNSPECIFIED':
      return DeadmanArmRefusedReason.DEADMAN_ARM_REFUSED_REASON_UNSPECIFIED
    case 1:
    case 'DEADMAN_ARM_REFUSED_REASON_OPEN_ORDER_CAP':
      return DeadmanArmRefusedReason.DEADMAN_ARM_REFUSED_REASON_OPEN_ORDER_CAP
    case 2:
    case 'DEADMAN_ARM_REFUSED_REASON_STALE_GENERATION':
      return DeadmanArmRefusedReason.DEADMAN_ARM_REFUSED_REASON_STALE_GENERATION
    case 3:
    case 'DEADMAN_ARM_REFUSED_REASON_RESERVATION_STORE_UNAVAILABLE':
      return DeadmanArmRefusedReason.DEADMAN_ARM_REFUSED_REASON_RESERVATION_STORE_UNAVAILABLE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return DeadmanArmRefusedReason.UNRECOGNIZED
  }
}

export function deadmanArmRefusedReasonToJSON(object: DeadmanArmRefusedReason): string {
  switch (object) {
    case DeadmanArmRefusedReason.DEADMAN_ARM_REFUSED_REASON_UNSPECIFIED:
      return 'DEADMAN_ARM_REFUSED_REASON_UNSPECIFIED'
    case DeadmanArmRefusedReason.DEADMAN_ARM_REFUSED_REASON_OPEN_ORDER_CAP:
      return 'DEADMAN_ARM_REFUSED_REASON_OPEN_ORDER_CAP'
    case DeadmanArmRefusedReason.DEADMAN_ARM_REFUSED_REASON_STALE_GENERATION:
      return 'DEADMAN_ARM_REFUSED_REASON_STALE_GENERATION'
    case DeadmanArmRefusedReason.DEADMAN_ARM_REFUSED_REASON_RESERVATION_STORE_UNAVAILABLE:
      return 'DEADMAN_ARM_REFUSED_REASON_RESERVATION_STORE_UNAVAILABLE'
    case DeadmanArmRefusedReason.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum OwnerTagKind {
  OWNER_TAG_KIND_UNSPECIFIED = 0,
  OWNER_TAG_KIND_LABEL = 1,
  OWNER_TAG_KIND_CLIENT_ID_PREFIX = 2,
  UNRECOGNIZED = -1,
}

export function ownerTagKindFromJSON(object: any): OwnerTagKind {
  switch (object) {
    case 0:
    case 'OWNER_TAG_KIND_UNSPECIFIED':
      return OwnerTagKind.OWNER_TAG_KIND_UNSPECIFIED
    case 1:
    case 'OWNER_TAG_KIND_LABEL':
      return OwnerTagKind.OWNER_TAG_KIND_LABEL
    case 2:
    case 'OWNER_TAG_KIND_CLIENT_ID_PREFIX':
      return OwnerTagKind.OWNER_TAG_KIND_CLIENT_ID_PREFIX
    case -1:
    case 'UNRECOGNIZED':
    default:
      return OwnerTagKind.UNRECOGNIZED
  }
}

export function ownerTagKindToJSON(object: OwnerTagKind): string {
  switch (object) {
    case OwnerTagKind.OWNER_TAG_KIND_UNSPECIFIED:
      return 'OWNER_TAG_KIND_UNSPECIFIED'
    case OwnerTagKind.OWNER_TAG_KIND_LABEL:
      return 'OWNER_TAG_KIND_LABEL'
    case OwnerTagKind.OWNER_TAG_KIND_CLIENT_ID_PREFIX:
      return 'OWNER_TAG_KIND_CLIENT_ID_PREFIX'
    case OwnerTagKind.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum OpenOrderCapSource {
  OPEN_ORDER_CAP_SOURCE_UNSPECIFIED = 0,
  OPEN_ORDER_CAP_SOURCE_INTROSPECTED = 1,
  OPEN_ORDER_CAP_SOURCE_CONFIGURED = 2,
  UNRECOGNIZED = -1,
}

export function openOrderCapSourceFromJSON(object: any): OpenOrderCapSource {
  switch (object) {
    case 0:
    case 'OPEN_ORDER_CAP_SOURCE_UNSPECIFIED':
      return OpenOrderCapSource.OPEN_ORDER_CAP_SOURCE_UNSPECIFIED
    case 1:
    case 'OPEN_ORDER_CAP_SOURCE_INTROSPECTED':
      return OpenOrderCapSource.OPEN_ORDER_CAP_SOURCE_INTROSPECTED
    case 2:
    case 'OPEN_ORDER_CAP_SOURCE_CONFIGURED':
      return OpenOrderCapSource.OPEN_ORDER_CAP_SOURCE_CONFIGURED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return OpenOrderCapSource.UNRECOGNIZED
  }
}

export function openOrderCapSourceToJSON(object: OpenOrderCapSource): string {
  switch (object) {
    case OpenOrderCapSource.OPEN_ORDER_CAP_SOURCE_UNSPECIFIED:
      return 'OPEN_ORDER_CAP_SOURCE_UNSPECIFIED'
    case OpenOrderCapSource.OPEN_ORDER_CAP_SOURCE_INTROSPECTED:
      return 'OPEN_ORDER_CAP_SOURCE_INTROSPECTED'
    case OpenOrderCapSource.OPEN_ORDER_CAP_SOURCE_CONFIGURED:
      return 'OPEN_ORDER_CAP_SOURCE_CONFIGURED'
    case OpenOrderCapSource.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** Notification message that supports extensible types */
export interface ServiceNotification {
  /** Account ID this notification relates to */
  accountId: string
  /** Timestamp when the notification was generated */
  timestamp: string
  orderExecutionError?: OrderExecutionError | undefined
  orderValidationError?: OrderValidationError | undefined
  orderResponse?: OrderResponse | undefined
  algoLifecycle?: AlgoLifecycleNotification | undefined
  securityAlert?: SecurityAlert | undefined
  venueNotice?: VenueNotice | undefined
  /** ENG-1063 D13-D17 (venue layer, `shared/mm-venue`). */
  venueConnectionState?: VenueConnectionState | undefined
  venueRateLimits?: VenueRateLimits | undefined
  deadmanArmed?: DeadmanArmed | undefined
  deadmanFired?: DeadmanFired | undefined
  /** ENG-1063 old Decision 28 (Derive). */
  tradeReverted?: TradeReverted | undefined
  deadmanArmRefused?: DeadmanArmRefused | undefined
  venueCapabilities?: VenueCapabilities | undefined
  /** ENG-1063 D21: the answer to `execution.SimulateMarginParams`. */
  marginSimulated?: MarginSimulated | undefined
}

export interface OrderExecutionError {
  errorMessage: string
  /**
   * Echoes the opaque correlation_id from the originating frontend request
   * (order or algo command) when one was supplied, so the UI can map this
   * error back to the action that caused it. Absent for server-originated
   * notices (e.g. resume-time cancellations).
   */
  correlationId?: string | undefined
}

/**
 * Order execution response notification.
 *
 * `exchange` is the underlying market the order traded against; `trade_venue`
 * is where the account routed the order (equal for full-stack venues, may
 * differ for cross-market routing such as IBKR against GLBX).
 */
export interface OrderResponse {
  orderId: string
  symbol: string
  exchange: Exchange
  status: OrderStatus
  /** Using string for precision */
  quantity: string
  price?: string | undefined
  filledQuantity?: string | undefined
  averagePrice?: string | undefined
  clientOrderId: string
  errorMessage?: string | undefined
  tradeVenue: TradeVenue
  side: OrderSide
  /** Unit of `quantity` and `filled_quantity`; see `common.trading.Order.denomination`. */
  denomination: Denomination
}

/** Order execution error notification */
export interface OrderValidationError {
  symbol: string
  errorMessage: string
  orderParams: NewOrderParams | undefined
}

/**
 * Algo lifecycle notification — emitted only for root algos (no parent_id)
 * at start, completion, cancellation, and failure.
 */
export interface AlgoLifecycleNotification {
  algoId: string
  algoType: AlgoType
  status: AlgoStatus
  symbol: string
  side: OrderSide
  totalQuantity: string
  filledQuantity: string
  /** Pre-rendered short summary, e.g. "TWAP BTC-PERPETUAL buy 0.5 completed". */
  message: string
  /**
   * Open inventory this run handed back when it ended, e.g.
   * "left open: 0.05 BTC-PERPETUAL and -88.3 IBIT".
   *
   * Present ONLY when the run stopped holding something the user now owns and
   * nothing is managing. Multi-leg algos (Spreader, cross-exchange arb) can end
   * — by cancel, expiry, loss limit or reject halt — without flattening, and
   * none of them place a compensating order. Single-order algos never set it:
   * a TWAP that finishes has delivered the position the user asked for, which
   * is not a residual.
   *
   * Structured rather than left inside `message` because it is the trigger for
   * acting, not just for displaying: it is what the alerts service gates the
   * "your algo stopped, review your positions" email on. Distinct from
   * `AlgoState.failure_reason`, which says why the run stopped — neither is a
   * superset of the other.
   */
  residual?: string | undefined
  /**
   * Why the run ended, e.g. "loss limit breached: -0.0104 below -0.01
   * (reference units)". Absent for an ordinary ending that needs no
   * explanation.
   *
   * Carried separately even though `message` already embeds it, because
   * `message` is a display string: it appends `residual` and the head line
   * around this text, so a consumer wanting the reason alone would have to
   * parse it back out. The email renders "why it stopped" and "what is open"
   * as two blocks and would otherwise print the residual in both, then
   * truncate the real reason to fit.
   */
  reason?: string | undefined
}

/**
 * User-facing security notice (e.g. a refresh-token replay was detected and a
 * session auto-revoked).
 *
 * public-api's per-account fanout was removed (a user-scoped event on an
 * account-scoped subject reached every co-user). exchange-lighter's venue
 * notices move to `VenueNotice` — but not at the same moment: telegram-bot has
 * to deploy first, because an older bot decodes an unknown oneof tag as `None`
 * and drops the frame. So this stays the live path for venue notices until
 * exchange-lighter's own deploy lands, and is unproduced only after that.
 *
 * Retained rather than reserved because it is the right home for a future
 * user-scoped security notice — see the phase-2 gate in the design doc.
 */
export interface SecurityAlert {
  message: string
}

/**
 * A notice from a trading venue about an account: liquidation, auto-deleverage,
 * or a venue announcement. Genuinely account-scoped, unlike SecurityAlert.
 *
 * Exists because `SecurityAlert` was the only bare-string variant, so
 * exchange-lighter borrowed it — which rendered every liquidation under a
 * "Security Alert" header. Kept a bare string deliberately: the fix is the name
 * and the rendering, not new structure. A `kind` enum can be appended at tag 2.
 */
export interface VenueNotice {
  message: string
}

/**
 * Internal cross-instance session-teardown event, published on NATS subject
 * session_invalidated.{user_id} by public-api and consumed by every public-api
 * instance to close live WebSockets. Exactly one of min_token_iat (nuke: close
 * all except keep_session_id) or revoked_session_id (single-session revoke) is
 * set.
 */
export interface SessionInvalidated {
  userId: string
  minTokenIat?: string | undefined
  revokedSessionId?: string | undefined
  keepSessionId?: string | undefined
}

/**
 * An external data API key was revoked, published on `api_key_revoked.{user_id}`
 * by public-api and consumed by every public-api instance to close the live
 * WebSockets holding that key. Core NATS, at-most-once by design: the durable
 * state is the revoked_at stamp in DynamoDB and the per-socket recheck timer is
 * the backstop for a missed publish — and the only mechanism at all for
 * `oems-admin api-key revoke`, which runs outside the VPC and cannot reach NATS.
 *
 * Deliberately NOT a field on SessionInvalidated, even though both close
 * sockets for one user. telegram-bot consumes `session_invalidated.*` and counts
 * an event naming neither a session nor a token floor as unusable, so a key
 * revocation would climb a counter that exists to sit at zero on a service that
 * has nothing to do with API keys.
 *
 * Keyed on the user in the subject and on the key in the body: the consumer
 * matches key_id, and the subject token is what a per-tenant consumer would
 * filter on.
 */
export interface ApiKeyRevoked {
  userId: string
  keyId: string
}

/**
 * A user's set of readable accounts changed, published on
 * `account_access_changed.{user_id}` by public-api whenever an account-access
 * LINK# row is created, removed or has its permission changed.
 *
 * Carries only the user id on purpose: every consumer already has to call
 * get_user_accounts to build its own view, and shipping the new set here would
 * be a second source of truth that can disagree with DynamoDB.
 *
 * Exists because access removal is otherwise invisible to anything holding a
 * derived account -> subscriber map. The telegram-bot builds exactly such a map
 * at enrolment; without this event a user removed from a shared account keeps
 * receiving its notifications until the bot process restarts.
 */
export interface AccountAccessChanged {
  userId: string
}

/**
 * One account auth-state transition, published by the DynamoDB write sites
 * (record_auth_success / record_auth_failure / activate_agent_wallet) on
 * `account_connectivity.{account_id}`. Consumed by the alerts-service to
 * email the account owner. Core NATS — at-most-once by design; the durable
 * auth state lives in DynamoDB regardless.
 */
export interface AccountConnectivityEvent {
  accountId: string
  /** Publish time, epoch ms. */
  timestamp: string
  previousStatus: AccountStatus
  newStatus: AccountStatus
  /** Set only when new_status == ACCOUNT_STATUS_AUTH_FAILED. */
  errorMessage?: string | undefined
  /**
   * True when this transition is the account's first-ever activation
   * (first_active_at was unset before the write). Only the publisher can
   * know this — the write itself stamps first_active_at, so a post-write
   * reader can never distinguish "Connected" from "Connected again".
   */
  firstActivation: boolean
  /**
   * Venue for email copy ("Your Bybit connection ..."); saves the consumer
   * an account lookup that could race a concurrent account deletion.
   */
  tradeVenue: TradeVenue
}

/** ENG-1063: the account's private venue socket opened or closed. */
export interface VenueConnectionState {
  accountId: string
  connected: boolean
  atMs: string
}

/**
 * ENG-1063 D16: the scope's budget per `window_ms`, and the open-order
 * reservations summed on that scope. An instance spends
 * `budget × own_reservation / reservations_total`.
 */
export interface VenueRateLimits {
  accountId: string
  scope: VenueRateLimitScope
  scopeKey: string
  matchingPerWindow: number
  cancelPerWindow: number
  windowMs: number
  source: VenueRateLimitSource
  readAtMs: string
  reservationsTotal: number
}

export interface DeadmanArmed {
  label: string
  generation: string
  deadlineMs: string
  openOrdersReserved: number
}

export interface DeadmanFired {
  label: string
  generation: string
  atMs: string
  cancelOk: boolean
  errorCode?: string | undefined
}

/**
 * ENG-1063 old Decision 28: a fill whose settlement batch failed (Derive v3
 * `batch_status` is one of the `*Error` stages). Published instead of a
 * fill, once per `trade_id`. `batch_status` is the venue's string verbatim.
 */
export interface TradeReverted {
  tradeId: string
  orderId: string
  instrumentName: string
  label: string
  batchStatus: string
  atMs: string
}

/**
 * ENG-1063 D17 / §4. `cap` is the account's allowed sum after headroom;
 * `reserved_total` the scope's sum without this arm.
 */
export interface DeadmanArmRefused {
  label: string
  generation: string
  reason: DeadmanArmRefusedReason
  cap: number
  reservedTotal: number
}

/**
 * ENG-1063 D13: what the venue offers this account. Published at login and
 * on every first arm of a generation. The algo adapts to these flags, never
 * to the venue name.
 */
export interface VenueCapabilities {
  accountId: string
  venue: TradeVenue
  amendKeepsPriorityOnSizeDown: boolean
  hasInPlaceAmend: boolean
  hasCancelOnDisconnect: boolean
  hasDcp: boolean
  hasMmp: boolean
  mmpEnabled: boolean
  hasStp: boolean
  ownerTag: OwnerTagKind
  maxOwnerTagLen: number
  openOrderCap: number
  openOrderCapSource: OpenOrderCapSource
  perInstrumentTps: number
  perInstrumentBurst: number
  isMarketMakerTier: boolean
  hasMarginSimulation: boolean
  batchMax: number
  rateScopeKey: string
  capScopeKey: string
}

/**
 * ENG-1063 D21: margin of `SimulateMarginParams.legs` on top of the account's
 * current portfolio. Exactly one of the margins pair or `error` is set;
 * `error = "unsupported"` where the venue offers no simulation.
 */
export interface MarginSimulated {
  correlationId: string
  initialMargin?: string | undefined
  maintenanceMargin?: string | undefined
  error?: string | undefined
}

function createBaseServiceNotification(): ServiceNotification {
  return {
    accountId: '',
    timestamp: '0',
    orderExecutionError: undefined,
    orderValidationError: undefined,
    orderResponse: undefined,
    algoLifecycle: undefined,
    securityAlert: undefined,
    venueNotice: undefined,
    venueConnectionState: undefined,
    venueRateLimits: undefined,
    deadmanArmed: undefined,
    deadmanFired: undefined,
    tradeReverted: undefined,
    deadmanArmRefused: undefined,
    venueCapabilities: undefined,
    marginSimulated: undefined,
  }
}

export const ServiceNotification: MessageFns<ServiceNotification> = {
  encode(message: ServiceNotification, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.timestamp !== '0') {
      writer.uint32(16).int64(message.timestamp)
    }
    if (message.orderExecutionError !== undefined) {
      OrderExecutionError.encode(message.orderExecutionError, writer.uint32(26).fork()).join()
    }
    if (message.orderValidationError !== undefined) {
      OrderValidationError.encode(message.orderValidationError, writer.uint32(34).fork()).join()
    }
    if (message.orderResponse !== undefined) {
      OrderResponse.encode(message.orderResponse, writer.uint32(42).fork()).join()
    }
    if (message.algoLifecycle !== undefined) {
      AlgoLifecycleNotification.encode(message.algoLifecycle, writer.uint32(50).fork()).join()
    }
    if (message.securityAlert !== undefined) {
      SecurityAlert.encode(message.securityAlert, writer.uint32(58).fork()).join()
    }
    if (message.venueNotice !== undefined) {
      VenueNotice.encode(message.venueNotice, writer.uint32(66).fork()).join()
    }
    if (message.venueConnectionState !== undefined) {
      VenueConnectionState.encode(message.venueConnectionState, writer.uint32(74).fork()).join()
    }
    if (message.venueRateLimits !== undefined) {
      VenueRateLimits.encode(message.venueRateLimits, writer.uint32(82).fork()).join()
    }
    if (message.deadmanArmed !== undefined) {
      DeadmanArmed.encode(message.deadmanArmed, writer.uint32(90).fork()).join()
    }
    if (message.deadmanFired !== undefined) {
      DeadmanFired.encode(message.deadmanFired, writer.uint32(98).fork()).join()
    }
    if (message.tradeReverted !== undefined) {
      TradeReverted.encode(message.tradeReverted, writer.uint32(106).fork()).join()
    }
    if (message.deadmanArmRefused !== undefined) {
      DeadmanArmRefused.encode(message.deadmanArmRefused, writer.uint32(114).fork()).join()
    }
    if (message.venueCapabilities !== undefined) {
      VenueCapabilities.encode(message.venueCapabilities, writer.uint32(122).fork()).join()
    }
    if (message.marginSimulated !== undefined) {
      MarginSimulated.encode(message.marginSimulated, writer.uint32(130).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServiceNotification {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseServiceNotification()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.timestamp = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.orderExecutionError = OrderExecutionError.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.orderValidationError = OrderValidationError.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.orderResponse = OrderResponse.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.algoLifecycle = AlgoLifecycleNotification.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.securityAlert = SecurityAlert.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.venueNotice = VenueNotice.decode(reader, reader.uint32())
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.venueConnectionState = VenueConnectionState.decode(reader, reader.uint32())
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.venueRateLimits = VenueRateLimits.decode(reader, reader.uint32())
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.deadmanArmed = DeadmanArmed.decode(reader, reader.uint32())
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.deadmanFired = DeadmanFired.decode(reader, reader.uint32())
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.tradeReverted = TradeReverted.decode(reader, reader.uint32())
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.deadmanArmRefused = DeadmanArmRefused.decode(reader, reader.uint32())
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.venueCapabilities = VenueCapabilities.decode(reader, reader.uint32())
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.marginSimulated = MarginSimulated.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ServiceNotification {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : '0',
      orderExecutionError: isSet(object.orderExecutionError)
        ? OrderExecutionError.fromJSON(object.orderExecutionError)
        : isSet(object.order_execution_error)
          ? OrderExecutionError.fromJSON(object.order_execution_error)
          : undefined,
      orderValidationError: isSet(object.orderValidationError)
        ? OrderValidationError.fromJSON(object.orderValidationError)
        : isSet(object.order_validation_error)
          ? OrderValidationError.fromJSON(object.order_validation_error)
          : undefined,
      orderResponse: isSet(object.orderResponse)
        ? OrderResponse.fromJSON(object.orderResponse)
        : isSet(object.order_response)
          ? OrderResponse.fromJSON(object.order_response)
          : undefined,
      algoLifecycle: isSet(object.algoLifecycle)
        ? AlgoLifecycleNotification.fromJSON(object.algoLifecycle)
        : isSet(object.algo_lifecycle)
          ? AlgoLifecycleNotification.fromJSON(object.algo_lifecycle)
          : undefined,
      securityAlert: isSet(object.securityAlert)
        ? SecurityAlert.fromJSON(object.securityAlert)
        : isSet(object.security_alert)
          ? SecurityAlert.fromJSON(object.security_alert)
          : undefined,
      venueNotice: isSet(object.venueNotice)
        ? VenueNotice.fromJSON(object.venueNotice)
        : isSet(object.venue_notice)
          ? VenueNotice.fromJSON(object.venue_notice)
          : undefined,
      venueConnectionState: isSet(object.venueConnectionState)
        ? VenueConnectionState.fromJSON(object.venueConnectionState)
        : isSet(object.venue_connection_state)
          ? VenueConnectionState.fromJSON(object.venue_connection_state)
          : undefined,
      venueRateLimits: isSet(object.venueRateLimits)
        ? VenueRateLimits.fromJSON(object.venueRateLimits)
        : isSet(object.venue_rate_limits)
          ? VenueRateLimits.fromJSON(object.venue_rate_limits)
          : undefined,
      deadmanArmed: isSet(object.deadmanArmed)
        ? DeadmanArmed.fromJSON(object.deadmanArmed)
        : isSet(object.deadman_armed)
          ? DeadmanArmed.fromJSON(object.deadman_armed)
          : undefined,
      deadmanFired: isSet(object.deadmanFired)
        ? DeadmanFired.fromJSON(object.deadmanFired)
        : isSet(object.deadman_fired)
          ? DeadmanFired.fromJSON(object.deadman_fired)
          : undefined,
      tradeReverted: isSet(object.tradeReverted)
        ? TradeReverted.fromJSON(object.tradeReverted)
        : isSet(object.trade_reverted)
          ? TradeReverted.fromJSON(object.trade_reverted)
          : undefined,
      deadmanArmRefused: isSet(object.deadmanArmRefused)
        ? DeadmanArmRefused.fromJSON(object.deadmanArmRefused)
        : isSet(object.deadman_arm_refused)
          ? DeadmanArmRefused.fromJSON(object.deadman_arm_refused)
          : undefined,
      venueCapabilities: isSet(object.venueCapabilities)
        ? VenueCapabilities.fromJSON(object.venueCapabilities)
        : isSet(object.venue_capabilities)
          ? VenueCapabilities.fromJSON(object.venue_capabilities)
          : undefined,
      marginSimulated: isSet(object.marginSimulated)
        ? MarginSimulated.fromJSON(object.marginSimulated)
        : isSet(object.margin_simulated)
          ? MarginSimulated.fromJSON(object.margin_simulated)
          : undefined,
    }
  },

  toJSON(message: ServiceNotification): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.timestamp !== '0') {
      obj.timestamp = message.timestamp
    }
    if (message.orderExecutionError !== undefined) {
      obj.orderExecutionError = OrderExecutionError.toJSON(message.orderExecutionError)
    }
    if (message.orderValidationError !== undefined) {
      obj.orderValidationError = OrderValidationError.toJSON(message.orderValidationError)
    }
    if (message.orderResponse !== undefined) {
      obj.orderResponse = OrderResponse.toJSON(message.orderResponse)
    }
    if (message.algoLifecycle !== undefined) {
      obj.algoLifecycle = AlgoLifecycleNotification.toJSON(message.algoLifecycle)
    }
    if (message.securityAlert !== undefined) {
      obj.securityAlert = SecurityAlert.toJSON(message.securityAlert)
    }
    if (message.venueNotice !== undefined) {
      obj.venueNotice = VenueNotice.toJSON(message.venueNotice)
    }
    if (message.venueConnectionState !== undefined) {
      obj.venueConnectionState = VenueConnectionState.toJSON(message.venueConnectionState)
    }
    if (message.venueRateLimits !== undefined) {
      obj.venueRateLimits = VenueRateLimits.toJSON(message.venueRateLimits)
    }
    if (message.deadmanArmed !== undefined) {
      obj.deadmanArmed = DeadmanArmed.toJSON(message.deadmanArmed)
    }
    if (message.deadmanFired !== undefined) {
      obj.deadmanFired = DeadmanFired.toJSON(message.deadmanFired)
    }
    if (message.tradeReverted !== undefined) {
      obj.tradeReverted = TradeReverted.toJSON(message.tradeReverted)
    }
    if (message.deadmanArmRefused !== undefined) {
      obj.deadmanArmRefused = DeadmanArmRefused.toJSON(message.deadmanArmRefused)
    }
    if (message.venueCapabilities !== undefined) {
      obj.venueCapabilities = VenueCapabilities.toJSON(message.venueCapabilities)
    }
    if (message.marginSimulated !== undefined) {
      obj.marginSimulated = MarginSimulated.toJSON(message.marginSimulated)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ServiceNotification>, I>>(base?: I): ServiceNotification {
    return ServiceNotification.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ServiceNotification>, I>>(
    object: I
  ): ServiceNotification {
    const message = createBaseServiceNotification()
    message.accountId = object.accountId ?? ''
    message.timestamp = object.timestamp ?? '0'
    message.orderExecutionError =
      object.orderExecutionError !== undefined && object.orderExecutionError !== null
        ? OrderExecutionError.fromPartial(object.orderExecutionError)
        : undefined
    message.orderValidationError =
      object.orderValidationError !== undefined && object.orderValidationError !== null
        ? OrderValidationError.fromPartial(object.orderValidationError)
        : undefined
    message.orderResponse =
      object.orderResponse !== undefined && object.orderResponse !== null
        ? OrderResponse.fromPartial(object.orderResponse)
        : undefined
    message.algoLifecycle =
      object.algoLifecycle !== undefined && object.algoLifecycle !== null
        ? AlgoLifecycleNotification.fromPartial(object.algoLifecycle)
        : undefined
    message.securityAlert =
      object.securityAlert !== undefined && object.securityAlert !== null
        ? SecurityAlert.fromPartial(object.securityAlert)
        : undefined
    message.venueNotice =
      object.venueNotice !== undefined && object.venueNotice !== null
        ? VenueNotice.fromPartial(object.venueNotice)
        : undefined
    message.venueConnectionState =
      object.venueConnectionState !== undefined && object.venueConnectionState !== null
        ? VenueConnectionState.fromPartial(object.venueConnectionState)
        : undefined
    message.venueRateLimits =
      object.venueRateLimits !== undefined && object.venueRateLimits !== null
        ? VenueRateLimits.fromPartial(object.venueRateLimits)
        : undefined
    message.deadmanArmed =
      object.deadmanArmed !== undefined && object.deadmanArmed !== null
        ? DeadmanArmed.fromPartial(object.deadmanArmed)
        : undefined
    message.deadmanFired =
      object.deadmanFired !== undefined && object.deadmanFired !== null
        ? DeadmanFired.fromPartial(object.deadmanFired)
        : undefined
    message.tradeReverted =
      object.tradeReverted !== undefined && object.tradeReverted !== null
        ? TradeReverted.fromPartial(object.tradeReverted)
        : undefined
    message.deadmanArmRefused =
      object.deadmanArmRefused !== undefined && object.deadmanArmRefused !== null
        ? DeadmanArmRefused.fromPartial(object.deadmanArmRefused)
        : undefined
    message.venueCapabilities =
      object.venueCapabilities !== undefined && object.venueCapabilities !== null
        ? VenueCapabilities.fromPartial(object.venueCapabilities)
        : undefined
    message.marginSimulated =
      object.marginSimulated !== undefined && object.marginSimulated !== null
        ? MarginSimulated.fromPartial(object.marginSimulated)
        : undefined
    return message
  },
}

function createBaseOrderExecutionError(): OrderExecutionError {
  return { errorMessage: '', correlationId: undefined }
}

export const OrderExecutionError: MessageFns<OrderExecutionError> = {
  encode(message: OrderExecutionError, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.errorMessage !== '') {
      writer.uint32(10).string(message.errorMessage)
    }
    if (message.correlationId !== undefined) {
      writer.uint32(18).string(message.correlationId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrderExecutionError {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrderExecutionError()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OrderExecutionError {
    return {
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : '',
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
    }
  },

  toJSON(message: OrderExecutionError): unknown {
    const obj: any = {}
    if (message.errorMessage !== '') {
      obj.errorMessage = message.errorMessage
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OrderExecutionError>, I>>(base?: I): OrderExecutionError {
    return OrderExecutionError.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OrderExecutionError>, I>>(
    object: I
  ): OrderExecutionError {
    const message = createBaseOrderExecutionError()
    message.errorMessage = object.errorMessage ?? ''
    message.correlationId = object.correlationId ?? undefined
    return message
  },
}

function createBaseOrderResponse(): OrderResponse {
  return {
    orderId: '',
    symbol: '',
    exchange: 0,
    status: 0,
    quantity: '',
    price: undefined,
    filledQuantity: undefined,
    averagePrice: undefined,
    clientOrderId: '',
    errorMessage: undefined,
    tradeVenue: 0,
    side: 0,
    denomination: 0,
  }
}

export const OrderResponse: MessageFns<OrderResponse> = {
  encode(message: OrderResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orderId !== '') {
      writer.uint32(10).string(message.orderId)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    if (message.exchange !== 0) {
      writer.uint32(24).int32(message.exchange)
    }
    if (message.status !== 0) {
      writer.uint32(32).int32(message.status)
    }
    if (message.quantity !== '') {
      writer.uint32(42).string(message.quantity)
    }
    if (message.price !== undefined) {
      writer.uint32(50).string(message.price)
    }
    if (message.filledQuantity !== undefined) {
      writer.uint32(58).string(message.filledQuantity)
    }
    if (message.averagePrice !== undefined) {
      writer.uint32(66).string(message.averagePrice)
    }
    if (message.clientOrderId !== '') {
      writer.uint32(74).string(message.clientOrderId)
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(82).string(message.errorMessage)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(88).int32(message.tradeVenue)
    }
    if (message.side !== 0) {
      writer.uint32(96).int32(message.side)
    }
    if (message.denomination !== 0) {
      writer.uint32(104).int32(message.denomination)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrderResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrderResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.orderId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.status = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.quantity = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.price = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.filledQuantity = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.averagePrice = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.clientOrderId = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 12: {
          if (tag !== 96) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.denomination = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OrderResponse {
    return {
      orderId: isSet(object.orderId)
        ? globalThis.String(object.orderId)
        : isSet(object.order_id)
          ? globalThis.String(object.order_id)
          : '',
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      status: isSet(object.status) ? orderStatusFromJSON(object.status) : 0,
      quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
      price: isSet(object.price) ? globalThis.String(object.price) : undefined,
      filledQuantity: isSet(object.filledQuantity)
        ? globalThis.String(object.filledQuantity)
        : isSet(object.filled_quantity)
          ? globalThis.String(object.filled_quantity)
          : undefined,
      averagePrice: isSet(object.averagePrice)
        ? globalThis.String(object.averagePrice)
        : isSet(object.average_price)
          ? globalThis.String(object.average_price)
          : undefined,
      clientOrderId: isSet(object.clientOrderId)
        ? globalThis.String(object.clientOrderId)
        : isSet(object.client_order_id)
          ? globalThis.String(object.client_order_id)
          : '',
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      side: isSet(object.side) ? orderSideFromJSON(object.side) : 0,
      denomination: isSet(object.denomination) ? denominationFromJSON(object.denomination) : 0,
    }
  },

  toJSON(message: OrderResponse): unknown {
    const obj: any = {}
    if (message.orderId !== '') {
      obj.orderId = message.orderId
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.status !== 0) {
      obj.status = orderStatusToJSON(message.status)
    }
    if (message.quantity !== '') {
      obj.quantity = message.quantity
    }
    if (message.price !== undefined) {
      obj.price = message.price
    }
    if (message.filledQuantity !== undefined) {
      obj.filledQuantity = message.filledQuantity
    }
    if (message.averagePrice !== undefined) {
      obj.averagePrice = message.averagePrice
    }
    if (message.clientOrderId !== '') {
      obj.clientOrderId = message.clientOrderId
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.side !== 0) {
      obj.side = orderSideToJSON(message.side)
    }
    if (message.denomination !== 0) {
      obj.denomination = denominationToJSON(message.denomination)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OrderResponse>, I>>(base?: I): OrderResponse {
    return OrderResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OrderResponse>, I>>(object: I): OrderResponse {
    const message = createBaseOrderResponse()
    message.orderId = object.orderId ?? ''
    message.symbol = object.symbol ?? ''
    message.exchange = object.exchange ?? 0
    message.status = object.status ?? 0
    message.quantity = object.quantity ?? ''
    message.price = object.price ?? undefined
    message.filledQuantity = object.filledQuantity ?? undefined
    message.averagePrice = object.averagePrice ?? undefined
    message.clientOrderId = object.clientOrderId ?? ''
    message.errorMessage = object.errorMessage ?? undefined
    message.tradeVenue = object.tradeVenue ?? 0
    message.side = object.side ?? 0
    message.denomination = object.denomination ?? 0
    return message
  },
}

function createBaseOrderValidationError(): OrderValidationError {
  return { symbol: '', errorMessage: '', orderParams: undefined }
}

export const OrderValidationError: MessageFns<OrderValidationError> = {
  encode(message: OrderValidationError, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.errorMessage !== '') {
      writer.uint32(26).string(message.errorMessage)
    }
    if (message.orderParams !== undefined) {
      NewOrderParams.encode(message.orderParams, writer.uint32(34).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrderValidationError {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrderValidationError()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.orderParams = NewOrderParams.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OrderValidationError {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : '',
      orderParams: isSet(object.orderParams)
        ? NewOrderParams.fromJSON(object.orderParams)
        : isSet(object.order_params)
          ? NewOrderParams.fromJSON(object.order_params)
          : undefined,
    }
  },

  toJSON(message: OrderValidationError): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.errorMessage !== '') {
      obj.errorMessage = message.errorMessage
    }
    if (message.orderParams !== undefined) {
      obj.orderParams = NewOrderParams.toJSON(message.orderParams)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OrderValidationError>, I>>(base?: I): OrderValidationError {
    return OrderValidationError.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OrderValidationError>, I>>(
    object: I
  ): OrderValidationError {
    const message = createBaseOrderValidationError()
    message.symbol = object.symbol ?? ''
    message.errorMessage = object.errorMessage ?? ''
    message.orderParams =
      object.orderParams !== undefined && object.orderParams !== null
        ? NewOrderParams.fromPartial(object.orderParams)
        : undefined
    return message
  },
}

function createBaseAlgoLifecycleNotification(): AlgoLifecycleNotification {
  return {
    algoId: '',
    algoType: 0,
    status: 0,
    symbol: '',
    side: 0,
    totalQuantity: '',
    filledQuantity: '',
    message: '',
    residual: undefined,
    reason: undefined,
  }
}

export const AlgoLifecycleNotification: MessageFns<AlgoLifecycleNotification> = {
  encode(
    message: AlgoLifecycleNotification,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.algoId !== '') {
      writer.uint32(10).string(message.algoId)
    }
    if (message.algoType !== 0) {
      writer.uint32(16).int32(message.algoType)
    }
    if (message.status !== 0) {
      writer.uint32(24).int32(message.status)
    }
    if (message.symbol !== '') {
      writer.uint32(34).string(message.symbol)
    }
    if (message.side !== 0) {
      writer.uint32(40).int32(message.side)
    }
    if (message.totalQuantity !== '') {
      writer.uint32(50).string(message.totalQuantity)
    }
    if (message.filledQuantity !== '') {
      writer.uint32(58).string(message.filledQuantity)
    }
    if (message.message !== '') {
      writer.uint32(66).string(message.message)
    }
    if (message.residual !== undefined) {
      writer.uint32(74).string(message.residual)
    }
    if (message.reason !== undefined) {
      writer.uint32(82).string(message.reason)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AlgoLifecycleNotification {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAlgoLifecycleNotification()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.algoId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.algoType = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.status = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.totalQuantity = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.filledQuantity = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.message = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.residual = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.reason = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AlgoLifecycleNotification {
    return {
      algoId: isSet(object.algoId)
        ? globalThis.String(object.algoId)
        : isSet(object.algo_id)
          ? globalThis.String(object.algo_id)
          : '',
      algoType: isSet(object.algoType)
        ? algoTypeFromJSON(object.algoType)
        : isSet(object.algo_type)
          ? algoTypeFromJSON(object.algo_type)
          : 0,
      status: isSet(object.status) ? algoStatusFromJSON(object.status) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      side: isSet(object.side) ? orderSideFromJSON(object.side) : 0,
      totalQuantity: isSet(object.totalQuantity)
        ? globalThis.String(object.totalQuantity)
        : isSet(object.total_quantity)
          ? globalThis.String(object.total_quantity)
          : '',
      filledQuantity: isSet(object.filledQuantity)
        ? globalThis.String(object.filledQuantity)
        : isSet(object.filled_quantity)
          ? globalThis.String(object.filled_quantity)
          : '',
      message: isSet(object.message) ? globalThis.String(object.message) : '',
      residual: isSet(object.residual) ? globalThis.String(object.residual) : undefined,
      reason: isSet(object.reason) ? globalThis.String(object.reason) : undefined,
    }
  },

  toJSON(message: AlgoLifecycleNotification): unknown {
    const obj: any = {}
    if (message.algoId !== '') {
      obj.algoId = message.algoId
    }
    if (message.algoType !== 0) {
      obj.algoType = algoTypeToJSON(message.algoType)
    }
    if (message.status !== 0) {
      obj.status = algoStatusToJSON(message.status)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.side !== 0) {
      obj.side = orderSideToJSON(message.side)
    }
    if (message.totalQuantity !== '') {
      obj.totalQuantity = message.totalQuantity
    }
    if (message.filledQuantity !== '') {
      obj.filledQuantity = message.filledQuantity
    }
    if (message.message !== '') {
      obj.message = message.message
    }
    if (message.residual !== undefined) {
      obj.residual = message.residual
    }
    if (message.reason !== undefined) {
      obj.reason = message.reason
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AlgoLifecycleNotification>, I>>(
    base?: I
  ): AlgoLifecycleNotification {
    return AlgoLifecycleNotification.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AlgoLifecycleNotification>, I>>(
    object: I
  ): AlgoLifecycleNotification {
    const message = createBaseAlgoLifecycleNotification()
    message.algoId = object.algoId ?? ''
    message.algoType = object.algoType ?? 0
    message.status = object.status ?? 0
    message.symbol = object.symbol ?? ''
    message.side = object.side ?? 0
    message.totalQuantity = object.totalQuantity ?? ''
    message.filledQuantity = object.filledQuantity ?? ''
    message.message = object.message ?? ''
    message.residual = object.residual ?? undefined
    message.reason = object.reason ?? undefined
    return message
  },
}

function createBaseSecurityAlert(): SecurityAlert {
  return { message: '' }
}

export const SecurityAlert: MessageFns<SecurityAlert> = {
  encode(message: SecurityAlert, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== '') {
      writer.uint32(10).string(message.message)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SecurityAlert {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSecurityAlert()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.message = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SecurityAlert {
    return { message: isSet(object.message) ? globalThis.String(object.message) : '' }
  },

  toJSON(message: SecurityAlert): unknown {
    const obj: any = {}
    if (message.message !== '') {
      obj.message = message.message
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SecurityAlert>, I>>(base?: I): SecurityAlert {
    return SecurityAlert.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SecurityAlert>, I>>(object: I): SecurityAlert {
    const message = createBaseSecurityAlert()
    message.message = object.message ?? ''
    return message
  },
}

function createBaseVenueNotice(): VenueNotice {
  return { message: '' }
}

export const VenueNotice: MessageFns<VenueNotice> = {
  encode(message: VenueNotice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== '') {
      writer.uint32(10).string(message.message)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VenueNotice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVenueNotice()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.message = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VenueNotice {
    return { message: isSet(object.message) ? globalThis.String(object.message) : '' }
  },

  toJSON(message: VenueNotice): unknown {
    const obj: any = {}
    if (message.message !== '') {
      obj.message = message.message
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VenueNotice>, I>>(base?: I): VenueNotice {
    return VenueNotice.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VenueNotice>, I>>(object: I): VenueNotice {
    const message = createBaseVenueNotice()
    message.message = object.message ?? ''
    return message
  },
}

function createBaseSessionInvalidated(): SessionInvalidated {
  return {
    userId: '',
    minTokenIat: undefined,
    revokedSessionId: undefined,
    keepSessionId: undefined,
  }
}

export const SessionInvalidated: MessageFns<SessionInvalidated> = {
  encode(message: SessionInvalidated, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== '') {
      writer.uint32(10).string(message.userId)
    }
    if (message.minTokenIat !== undefined) {
      writer.uint32(16).int64(message.minTokenIat)
    }
    if (message.revokedSessionId !== undefined) {
      writer.uint32(26).string(message.revokedSessionId)
    }
    if (message.keepSessionId !== undefined) {
      writer.uint32(34).string(message.keepSessionId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SessionInvalidated {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSessionInvalidated()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.userId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.minTokenIat = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.revokedSessionId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.keepSessionId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SessionInvalidated {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
          ? globalThis.String(object.user_id)
          : '',
      minTokenIat: isSet(object.minTokenIat)
        ? globalThis.String(object.minTokenIat)
        : isSet(object.min_token_iat)
          ? globalThis.String(object.min_token_iat)
          : undefined,
      revokedSessionId: isSet(object.revokedSessionId)
        ? globalThis.String(object.revokedSessionId)
        : isSet(object.revoked_session_id)
          ? globalThis.String(object.revoked_session_id)
          : undefined,
      keepSessionId: isSet(object.keepSessionId)
        ? globalThis.String(object.keepSessionId)
        : isSet(object.keep_session_id)
          ? globalThis.String(object.keep_session_id)
          : undefined,
    }
  },

  toJSON(message: SessionInvalidated): unknown {
    const obj: any = {}
    if (message.userId !== '') {
      obj.userId = message.userId
    }
    if (message.minTokenIat !== undefined) {
      obj.minTokenIat = message.minTokenIat
    }
    if (message.revokedSessionId !== undefined) {
      obj.revokedSessionId = message.revokedSessionId
    }
    if (message.keepSessionId !== undefined) {
      obj.keepSessionId = message.keepSessionId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SessionInvalidated>, I>>(base?: I): SessionInvalidated {
    return SessionInvalidated.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SessionInvalidated>, I>>(object: I): SessionInvalidated {
    const message = createBaseSessionInvalidated()
    message.userId = object.userId ?? ''
    message.minTokenIat = object.minTokenIat ?? undefined
    message.revokedSessionId = object.revokedSessionId ?? undefined
    message.keepSessionId = object.keepSessionId ?? undefined
    return message
  },
}

function createBaseApiKeyRevoked(): ApiKeyRevoked {
  return { userId: '', keyId: '' }
}

export const ApiKeyRevoked: MessageFns<ApiKeyRevoked> = {
  encode(message: ApiKeyRevoked, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== '') {
      writer.uint32(10).string(message.userId)
    }
    if (message.keyId !== '') {
      writer.uint32(18).string(message.keyId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiKeyRevoked {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseApiKeyRevoked()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.userId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.keyId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ApiKeyRevoked {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
          ? globalThis.String(object.user_id)
          : '',
      keyId: isSet(object.keyId)
        ? globalThis.String(object.keyId)
        : isSet(object.key_id)
          ? globalThis.String(object.key_id)
          : '',
    }
  },

  toJSON(message: ApiKeyRevoked): unknown {
    const obj: any = {}
    if (message.userId !== '') {
      obj.userId = message.userId
    }
    if (message.keyId !== '') {
      obj.keyId = message.keyId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ApiKeyRevoked>, I>>(base?: I): ApiKeyRevoked {
    return ApiKeyRevoked.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ApiKeyRevoked>, I>>(object: I): ApiKeyRevoked {
    const message = createBaseApiKeyRevoked()
    message.userId = object.userId ?? ''
    message.keyId = object.keyId ?? ''
    return message
  },
}

function createBaseAccountAccessChanged(): AccountAccessChanged {
  return { userId: '' }
}

export const AccountAccessChanged: MessageFns<AccountAccessChanged> = {
  encode(message: AccountAccessChanged, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== '') {
      writer.uint32(10).string(message.userId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AccountAccessChanged {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAccountAccessChanged()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.userId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AccountAccessChanged {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
          ? globalThis.String(object.user_id)
          : '',
    }
  },

  toJSON(message: AccountAccessChanged): unknown {
    const obj: any = {}
    if (message.userId !== '') {
      obj.userId = message.userId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AccountAccessChanged>, I>>(base?: I): AccountAccessChanged {
    return AccountAccessChanged.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AccountAccessChanged>, I>>(
    object: I
  ): AccountAccessChanged {
    const message = createBaseAccountAccessChanged()
    message.userId = object.userId ?? ''
    return message
  },
}

function createBaseAccountConnectivityEvent(): AccountConnectivityEvent {
  return {
    accountId: '',
    timestamp: '0',
    previousStatus: 0,
    newStatus: 0,
    errorMessage: undefined,
    firstActivation: false,
    tradeVenue: 0,
  }
}

export const AccountConnectivityEvent: MessageFns<AccountConnectivityEvent> = {
  encode(
    message: AccountConnectivityEvent,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.timestamp !== '0') {
      writer.uint32(16).int64(message.timestamp)
    }
    if (message.previousStatus !== 0) {
      writer.uint32(24).int32(message.previousStatus)
    }
    if (message.newStatus !== 0) {
      writer.uint32(32).int32(message.newStatus)
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(42).string(message.errorMessage)
    }
    if (message.firstActivation !== false) {
      writer.uint32(48).bool(message.firstActivation)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(56).int32(message.tradeVenue)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AccountConnectivityEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAccountConnectivityEvent()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.timestamp = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.previousStatus = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.newStatus = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.firstActivation = reader.bool()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AccountConnectivityEvent {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : '0',
      previousStatus: isSet(object.previousStatus)
        ? accountStatusFromJSON(object.previousStatus)
        : isSet(object.previous_status)
          ? accountStatusFromJSON(object.previous_status)
          : 0,
      newStatus: isSet(object.newStatus)
        ? accountStatusFromJSON(object.newStatus)
        : isSet(object.new_status)
          ? accountStatusFromJSON(object.new_status)
          : 0,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
      firstActivation: isSet(object.firstActivation)
        ? globalThis.Boolean(object.firstActivation)
        : isSet(object.first_activation)
          ? globalThis.Boolean(object.first_activation)
          : false,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
    }
  },

  toJSON(message: AccountConnectivityEvent): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.timestamp !== '0') {
      obj.timestamp = message.timestamp
    }
    if (message.previousStatus !== 0) {
      obj.previousStatus = accountStatusToJSON(message.previousStatus)
    }
    if (message.newStatus !== 0) {
      obj.newStatus = accountStatusToJSON(message.newStatus)
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    if (message.firstActivation !== false) {
      obj.firstActivation = message.firstActivation
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AccountConnectivityEvent>, I>>(
    base?: I
  ): AccountConnectivityEvent {
    return AccountConnectivityEvent.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AccountConnectivityEvent>, I>>(
    object: I
  ): AccountConnectivityEvent {
    const message = createBaseAccountConnectivityEvent()
    message.accountId = object.accountId ?? ''
    message.timestamp = object.timestamp ?? '0'
    message.previousStatus = object.previousStatus ?? 0
    message.newStatus = object.newStatus ?? 0
    message.errorMessage = object.errorMessage ?? undefined
    message.firstActivation = object.firstActivation ?? false
    message.tradeVenue = object.tradeVenue ?? 0
    return message
  },
}

function createBaseVenueConnectionState(): VenueConnectionState {
  return { accountId: '', connected: false, atMs: '0' }
}

export const VenueConnectionState: MessageFns<VenueConnectionState> = {
  encode(message: VenueConnectionState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.connected !== false) {
      writer.uint32(16).bool(message.connected)
    }
    if (message.atMs !== '0') {
      writer.uint32(24).int64(message.atMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VenueConnectionState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVenueConnectionState()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.connected = reader.bool()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.atMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VenueConnectionState {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      connected: isSet(object.connected) ? globalThis.Boolean(object.connected) : false,
      atMs: isSet(object.atMs)
        ? globalThis.String(object.atMs)
        : isSet(object.at_ms)
          ? globalThis.String(object.at_ms)
          : '0',
    }
  },

  toJSON(message: VenueConnectionState): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.connected !== false) {
      obj.connected = message.connected
    }
    if (message.atMs !== '0') {
      obj.atMs = message.atMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VenueConnectionState>, I>>(base?: I): VenueConnectionState {
    return VenueConnectionState.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VenueConnectionState>, I>>(
    object: I
  ): VenueConnectionState {
    const message = createBaseVenueConnectionState()
    message.accountId = object.accountId ?? ''
    message.connected = object.connected ?? false
    message.atMs = object.atMs ?? '0'
    return message
  },
}

function createBaseVenueRateLimits(): VenueRateLimits {
  return {
    accountId: '',
    scope: 0,
    scopeKey: '',
    matchingPerWindow: 0,
    cancelPerWindow: 0,
    windowMs: 0,
    source: 0,
    readAtMs: '0',
    reservationsTotal: 0,
  }
}

export const VenueRateLimits: MessageFns<VenueRateLimits> = {
  encode(message: VenueRateLimits, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.scope !== 0) {
      writer.uint32(16).int32(message.scope)
    }
    if (message.scopeKey !== '') {
      writer.uint32(26).string(message.scopeKey)
    }
    if (message.matchingPerWindow !== 0) {
      writer.uint32(32).uint32(message.matchingPerWindow)
    }
    if (message.cancelPerWindow !== 0) {
      writer.uint32(40).uint32(message.cancelPerWindow)
    }
    if (message.windowMs !== 0) {
      writer.uint32(48).uint32(message.windowMs)
    }
    if (message.source !== 0) {
      writer.uint32(56).int32(message.source)
    }
    if (message.readAtMs !== '0') {
      writer.uint32(64).int64(message.readAtMs)
    }
    if (message.reservationsTotal !== 0) {
      writer.uint32(72).uint32(message.reservationsTotal)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VenueRateLimits {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVenueRateLimits()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.scope = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.scopeKey = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.matchingPerWindow = reader.uint32()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.cancelPerWindow = reader.uint32()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.windowMs = reader.uint32()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.source = reader.int32() as any
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.readAtMs = reader.int64().toString()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.reservationsTotal = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VenueRateLimits {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      scope: isSet(object.scope) ? venueRateLimitScopeFromJSON(object.scope) : 0,
      scopeKey: isSet(object.scopeKey)
        ? globalThis.String(object.scopeKey)
        : isSet(object.scope_key)
          ? globalThis.String(object.scope_key)
          : '',
      matchingPerWindow: isSet(object.matchingPerWindow)
        ? globalThis.Number(object.matchingPerWindow)
        : isSet(object.matching_per_window)
          ? globalThis.Number(object.matching_per_window)
          : 0,
      cancelPerWindow: isSet(object.cancelPerWindow)
        ? globalThis.Number(object.cancelPerWindow)
        : isSet(object.cancel_per_window)
          ? globalThis.Number(object.cancel_per_window)
          : 0,
      windowMs: isSet(object.windowMs)
        ? globalThis.Number(object.windowMs)
        : isSet(object.window_ms)
          ? globalThis.Number(object.window_ms)
          : 0,
      source: isSet(object.source) ? venueRateLimitSourceFromJSON(object.source) : 0,
      readAtMs: isSet(object.readAtMs)
        ? globalThis.String(object.readAtMs)
        : isSet(object.read_at_ms)
          ? globalThis.String(object.read_at_ms)
          : '0',
      reservationsTotal: isSet(object.reservationsTotal)
        ? globalThis.Number(object.reservationsTotal)
        : isSet(object.reservations_total)
          ? globalThis.Number(object.reservations_total)
          : 0,
    }
  },

  toJSON(message: VenueRateLimits): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.scope !== 0) {
      obj.scope = venueRateLimitScopeToJSON(message.scope)
    }
    if (message.scopeKey !== '') {
      obj.scopeKey = message.scopeKey
    }
    if (message.matchingPerWindow !== 0) {
      obj.matchingPerWindow = Math.round(message.matchingPerWindow)
    }
    if (message.cancelPerWindow !== 0) {
      obj.cancelPerWindow = Math.round(message.cancelPerWindow)
    }
    if (message.windowMs !== 0) {
      obj.windowMs = Math.round(message.windowMs)
    }
    if (message.source !== 0) {
      obj.source = venueRateLimitSourceToJSON(message.source)
    }
    if (message.readAtMs !== '0') {
      obj.readAtMs = message.readAtMs
    }
    if (message.reservationsTotal !== 0) {
      obj.reservationsTotal = Math.round(message.reservationsTotal)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VenueRateLimits>, I>>(base?: I): VenueRateLimits {
    return VenueRateLimits.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VenueRateLimits>, I>>(object: I): VenueRateLimits {
    const message = createBaseVenueRateLimits()
    message.accountId = object.accountId ?? ''
    message.scope = object.scope ?? 0
    message.scopeKey = object.scopeKey ?? ''
    message.matchingPerWindow = object.matchingPerWindow ?? 0
    message.cancelPerWindow = object.cancelPerWindow ?? 0
    message.windowMs = object.windowMs ?? 0
    message.source = object.source ?? 0
    message.readAtMs = object.readAtMs ?? '0'
    message.reservationsTotal = object.reservationsTotal ?? 0
    return message
  },
}

function createBaseDeadmanArmed(): DeadmanArmed {
  return { label: '', generation: '0', deadlineMs: '0', openOrdersReserved: 0 }
}

export const DeadmanArmed: MessageFns<DeadmanArmed> = {
  encode(message: DeadmanArmed, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.label !== '') {
      writer.uint32(10).string(message.label)
    }
    if (message.generation !== '0') {
      writer.uint32(16).uint64(message.generation)
    }
    if (message.deadlineMs !== '0') {
      writer.uint32(24).int64(message.deadlineMs)
    }
    if (message.openOrdersReserved !== 0) {
      writer.uint32(32).uint32(message.openOrdersReserved)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeadmanArmed {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeadmanArmed()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.label = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.generation = reader.uint64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.deadlineMs = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.openOrdersReserved = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeadmanArmed {
    return {
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      generation: isSet(object.generation) ? globalThis.String(object.generation) : '0',
      deadlineMs: isSet(object.deadlineMs)
        ? globalThis.String(object.deadlineMs)
        : isSet(object.deadline_ms)
          ? globalThis.String(object.deadline_ms)
          : '0',
      openOrdersReserved: isSet(object.openOrdersReserved)
        ? globalThis.Number(object.openOrdersReserved)
        : isSet(object.open_orders_reserved)
          ? globalThis.Number(object.open_orders_reserved)
          : 0,
    }
  },

  toJSON(message: DeadmanArmed): unknown {
    const obj: any = {}
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.generation !== '0') {
      obj.generation = message.generation
    }
    if (message.deadlineMs !== '0') {
      obj.deadlineMs = message.deadlineMs
    }
    if (message.openOrdersReserved !== 0) {
      obj.openOrdersReserved = Math.round(message.openOrdersReserved)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeadmanArmed>, I>>(base?: I): DeadmanArmed {
    return DeadmanArmed.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeadmanArmed>, I>>(object: I): DeadmanArmed {
    const message = createBaseDeadmanArmed()
    message.label = object.label ?? ''
    message.generation = object.generation ?? '0'
    message.deadlineMs = object.deadlineMs ?? '0'
    message.openOrdersReserved = object.openOrdersReserved ?? 0
    return message
  },
}

function createBaseDeadmanFired(): DeadmanFired {
  return { label: '', generation: '0', atMs: '0', cancelOk: false, errorCode: undefined }
}

export const DeadmanFired: MessageFns<DeadmanFired> = {
  encode(message: DeadmanFired, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.label !== '') {
      writer.uint32(10).string(message.label)
    }
    if (message.generation !== '0') {
      writer.uint32(16).uint64(message.generation)
    }
    if (message.atMs !== '0') {
      writer.uint32(24).int64(message.atMs)
    }
    if (message.cancelOk !== false) {
      writer.uint32(32).bool(message.cancelOk)
    }
    if (message.errorCode !== undefined) {
      writer.uint32(42).string(message.errorCode)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeadmanFired {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeadmanFired()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.label = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.generation = reader.uint64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.atMs = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.cancelOk = reader.bool()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.errorCode = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeadmanFired {
    return {
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      generation: isSet(object.generation) ? globalThis.String(object.generation) : '0',
      atMs: isSet(object.atMs)
        ? globalThis.String(object.atMs)
        : isSet(object.at_ms)
          ? globalThis.String(object.at_ms)
          : '0',
      cancelOk: isSet(object.cancelOk)
        ? globalThis.Boolean(object.cancelOk)
        : isSet(object.cancel_ok)
          ? globalThis.Boolean(object.cancel_ok)
          : false,
      errorCode: isSet(object.errorCode)
        ? globalThis.String(object.errorCode)
        : isSet(object.error_code)
          ? globalThis.String(object.error_code)
          : undefined,
    }
  },

  toJSON(message: DeadmanFired): unknown {
    const obj: any = {}
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.generation !== '0') {
      obj.generation = message.generation
    }
    if (message.atMs !== '0') {
      obj.atMs = message.atMs
    }
    if (message.cancelOk !== false) {
      obj.cancelOk = message.cancelOk
    }
    if (message.errorCode !== undefined) {
      obj.errorCode = message.errorCode
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeadmanFired>, I>>(base?: I): DeadmanFired {
    return DeadmanFired.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeadmanFired>, I>>(object: I): DeadmanFired {
    const message = createBaseDeadmanFired()
    message.label = object.label ?? ''
    message.generation = object.generation ?? '0'
    message.atMs = object.atMs ?? '0'
    message.cancelOk = object.cancelOk ?? false
    message.errorCode = object.errorCode ?? undefined
    return message
  },
}

function createBaseTradeReverted(): TradeReverted {
  return { tradeId: '', orderId: '', instrumentName: '', label: '', batchStatus: '', atMs: '0' }
}

export const TradeReverted: MessageFns<TradeReverted> = {
  encode(message: TradeReverted, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tradeId !== '') {
      writer.uint32(10).string(message.tradeId)
    }
    if (message.orderId !== '') {
      writer.uint32(18).string(message.orderId)
    }
    if (message.instrumentName !== '') {
      writer.uint32(26).string(message.instrumentName)
    }
    if (message.label !== '') {
      writer.uint32(34).string(message.label)
    }
    if (message.batchStatus !== '') {
      writer.uint32(42).string(message.batchStatus)
    }
    if (message.atMs !== '0') {
      writer.uint32(48).int64(message.atMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TradeReverted {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTradeReverted()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.tradeId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.orderId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.instrumentName = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.label = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.batchStatus = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.atMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TradeReverted {
    return {
      tradeId: isSet(object.tradeId)
        ? globalThis.String(object.tradeId)
        : isSet(object.trade_id)
          ? globalThis.String(object.trade_id)
          : '',
      orderId: isSet(object.orderId)
        ? globalThis.String(object.orderId)
        : isSet(object.order_id)
          ? globalThis.String(object.order_id)
          : '',
      instrumentName: isSet(object.instrumentName)
        ? globalThis.String(object.instrumentName)
        : isSet(object.instrument_name)
          ? globalThis.String(object.instrument_name)
          : '',
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      batchStatus: isSet(object.batchStatus)
        ? globalThis.String(object.batchStatus)
        : isSet(object.batch_status)
          ? globalThis.String(object.batch_status)
          : '',
      atMs: isSet(object.atMs)
        ? globalThis.String(object.atMs)
        : isSet(object.at_ms)
          ? globalThis.String(object.at_ms)
          : '0',
    }
  },

  toJSON(message: TradeReverted): unknown {
    const obj: any = {}
    if (message.tradeId !== '') {
      obj.tradeId = message.tradeId
    }
    if (message.orderId !== '') {
      obj.orderId = message.orderId
    }
    if (message.instrumentName !== '') {
      obj.instrumentName = message.instrumentName
    }
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.batchStatus !== '') {
      obj.batchStatus = message.batchStatus
    }
    if (message.atMs !== '0') {
      obj.atMs = message.atMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TradeReverted>, I>>(base?: I): TradeReverted {
    return TradeReverted.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TradeReverted>, I>>(object: I): TradeReverted {
    const message = createBaseTradeReverted()
    message.tradeId = object.tradeId ?? ''
    message.orderId = object.orderId ?? ''
    message.instrumentName = object.instrumentName ?? ''
    message.label = object.label ?? ''
    message.batchStatus = object.batchStatus ?? ''
    message.atMs = object.atMs ?? '0'
    return message
  },
}

function createBaseDeadmanArmRefused(): DeadmanArmRefused {
  return { label: '', generation: '0', reason: 0, cap: 0, reservedTotal: 0 }
}

export const DeadmanArmRefused: MessageFns<DeadmanArmRefused> = {
  encode(message: DeadmanArmRefused, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.label !== '') {
      writer.uint32(10).string(message.label)
    }
    if (message.generation !== '0') {
      writer.uint32(16).uint64(message.generation)
    }
    if (message.reason !== 0) {
      writer.uint32(24).int32(message.reason)
    }
    if (message.cap !== 0) {
      writer.uint32(32).uint32(message.cap)
    }
    if (message.reservedTotal !== 0) {
      writer.uint32(40).uint32(message.reservedTotal)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeadmanArmRefused {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeadmanArmRefused()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.label = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.generation = reader.uint64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.reason = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.cap = reader.uint32()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.reservedTotal = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeadmanArmRefused {
    return {
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      generation: isSet(object.generation) ? globalThis.String(object.generation) : '0',
      reason: isSet(object.reason) ? deadmanArmRefusedReasonFromJSON(object.reason) : 0,
      cap: isSet(object.cap) ? globalThis.Number(object.cap) : 0,
      reservedTotal: isSet(object.reservedTotal)
        ? globalThis.Number(object.reservedTotal)
        : isSet(object.reserved_total)
          ? globalThis.Number(object.reserved_total)
          : 0,
    }
  },

  toJSON(message: DeadmanArmRefused): unknown {
    const obj: any = {}
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.generation !== '0') {
      obj.generation = message.generation
    }
    if (message.reason !== 0) {
      obj.reason = deadmanArmRefusedReasonToJSON(message.reason)
    }
    if (message.cap !== 0) {
      obj.cap = Math.round(message.cap)
    }
    if (message.reservedTotal !== 0) {
      obj.reservedTotal = Math.round(message.reservedTotal)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeadmanArmRefused>, I>>(base?: I): DeadmanArmRefused {
    return DeadmanArmRefused.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeadmanArmRefused>, I>>(object: I): DeadmanArmRefused {
    const message = createBaseDeadmanArmRefused()
    message.label = object.label ?? ''
    message.generation = object.generation ?? '0'
    message.reason = object.reason ?? 0
    message.cap = object.cap ?? 0
    message.reservedTotal = object.reservedTotal ?? 0
    return message
  },
}

function createBaseVenueCapabilities(): VenueCapabilities {
  return {
    accountId: '',
    venue: 0,
    amendKeepsPriorityOnSizeDown: false,
    hasInPlaceAmend: false,
    hasCancelOnDisconnect: false,
    hasDcp: false,
    hasMmp: false,
    mmpEnabled: false,
    hasStp: false,
    ownerTag: 0,
    maxOwnerTagLen: 0,
    openOrderCap: 0,
    openOrderCapSource: 0,
    perInstrumentTps: 0,
    perInstrumentBurst: 0,
    isMarketMakerTier: false,
    hasMarginSimulation: false,
    batchMax: 0,
    rateScopeKey: '',
    capScopeKey: '',
  }
}

export const VenueCapabilities: MessageFns<VenueCapabilities> = {
  encode(message: VenueCapabilities, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.venue !== 0) {
      writer.uint32(16).int32(message.venue)
    }
    if (message.amendKeepsPriorityOnSizeDown !== false) {
      writer.uint32(24).bool(message.amendKeepsPriorityOnSizeDown)
    }
    if (message.hasInPlaceAmend !== false) {
      writer.uint32(32).bool(message.hasInPlaceAmend)
    }
    if (message.hasCancelOnDisconnect !== false) {
      writer.uint32(40).bool(message.hasCancelOnDisconnect)
    }
    if (message.hasDcp !== false) {
      writer.uint32(48).bool(message.hasDcp)
    }
    if (message.hasMmp !== false) {
      writer.uint32(56).bool(message.hasMmp)
    }
    if (message.mmpEnabled !== false) {
      writer.uint32(64).bool(message.mmpEnabled)
    }
    if (message.hasStp !== false) {
      writer.uint32(72).bool(message.hasStp)
    }
    if (message.ownerTag !== 0) {
      writer.uint32(80).int32(message.ownerTag)
    }
    if (message.maxOwnerTagLen !== 0) {
      writer.uint32(88).uint32(message.maxOwnerTagLen)
    }
    if (message.openOrderCap !== 0) {
      writer.uint32(96).uint32(message.openOrderCap)
    }
    if (message.openOrderCapSource !== 0) {
      writer.uint32(104).int32(message.openOrderCapSource)
    }
    if (message.perInstrumentTps !== 0) {
      writer.uint32(112).uint32(message.perInstrumentTps)
    }
    if (message.perInstrumentBurst !== 0) {
      writer.uint32(120).uint32(message.perInstrumentBurst)
    }
    if (message.isMarketMakerTier !== false) {
      writer.uint32(128).bool(message.isMarketMakerTier)
    }
    if (message.hasMarginSimulation !== false) {
      writer.uint32(136).bool(message.hasMarginSimulation)
    }
    if (message.batchMax !== 0) {
      writer.uint32(144).uint32(message.batchMax)
    }
    if (message.rateScopeKey !== '') {
      writer.uint32(154).string(message.rateScopeKey)
    }
    if (message.capScopeKey !== '') {
      writer.uint32(162).string(message.capScopeKey)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VenueCapabilities {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVenueCapabilities()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.venue = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.amendKeepsPriorityOnSizeDown = reader.bool()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.hasInPlaceAmend = reader.bool()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.hasCancelOnDisconnect = reader.bool()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.hasDcp = reader.bool()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.hasMmp = reader.bool()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.mmpEnabled = reader.bool()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.hasStp = reader.bool()
          continue
        }
        case 10: {
          if (tag !== 80) {
            break
          }

          message.ownerTag = reader.int32() as any
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.maxOwnerTagLen = reader.uint32()
          continue
        }
        case 12: {
          if (tag !== 96) {
            break
          }

          message.openOrderCap = reader.uint32()
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.openOrderCapSource = reader.int32() as any
          continue
        }
        case 14: {
          if (tag !== 112) {
            break
          }

          message.perInstrumentTps = reader.uint32()
          continue
        }
        case 15: {
          if (tag !== 120) {
            break
          }

          message.perInstrumentBurst = reader.uint32()
          continue
        }
        case 16: {
          if (tag !== 128) {
            break
          }

          message.isMarketMakerTier = reader.bool()
          continue
        }
        case 17: {
          if (tag !== 136) {
            break
          }

          message.hasMarginSimulation = reader.bool()
          continue
        }
        case 18: {
          if (tag !== 144) {
            break
          }

          message.batchMax = reader.uint32()
          continue
        }
        case 19: {
          if (tag !== 154) {
            break
          }

          message.rateScopeKey = reader.string()
          continue
        }
        case 20: {
          if (tag !== 162) {
            break
          }

          message.capScopeKey = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VenueCapabilities {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      venue: isSet(object.venue) ? tradeVenueFromJSON(object.venue) : 0,
      amendKeepsPriorityOnSizeDown: isSet(object.amendKeepsPriorityOnSizeDown)
        ? globalThis.Boolean(object.amendKeepsPriorityOnSizeDown)
        : isSet(object.amend_keeps_priority_on_size_down)
          ? globalThis.Boolean(object.amend_keeps_priority_on_size_down)
          : false,
      hasInPlaceAmend: isSet(object.hasInPlaceAmend)
        ? globalThis.Boolean(object.hasInPlaceAmend)
        : isSet(object.has_in_place_amend)
          ? globalThis.Boolean(object.has_in_place_amend)
          : false,
      hasCancelOnDisconnect: isSet(object.hasCancelOnDisconnect)
        ? globalThis.Boolean(object.hasCancelOnDisconnect)
        : isSet(object.has_cancel_on_disconnect)
          ? globalThis.Boolean(object.has_cancel_on_disconnect)
          : false,
      hasDcp: isSet(object.hasDcp)
        ? globalThis.Boolean(object.hasDcp)
        : isSet(object.has_dcp)
          ? globalThis.Boolean(object.has_dcp)
          : false,
      hasMmp: isSet(object.hasMmp)
        ? globalThis.Boolean(object.hasMmp)
        : isSet(object.has_mmp)
          ? globalThis.Boolean(object.has_mmp)
          : false,
      mmpEnabled: isSet(object.mmpEnabled)
        ? globalThis.Boolean(object.mmpEnabled)
        : isSet(object.mmp_enabled)
          ? globalThis.Boolean(object.mmp_enabled)
          : false,
      hasStp: isSet(object.hasStp)
        ? globalThis.Boolean(object.hasStp)
        : isSet(object.has_stp)
          ? globalThis.Boolean(object.has_stp)
          : false,
      ownerTag: isSet(object.ownerTag)
        ? ownerTagKindFromJSON(object.ownerTag)
        : isSet(object.owner_tag)
          ? ownerTagKindFromJSON(object.owner_tag)
          : 0,
      maxOwnerTagLen: isSet(object.maxOwnerTagLen)
        ? globalThis.Number(object.maxOwnerTagLen)
        : isSet(object.max_owner_tag_len)
          ? globalThis.Number(object.max_owner_tag_len)
          : 0,
      openOrderCap: isSet(object.openOrderCap)
        ? globalThis.Number(object.openOrderCap)
        : isSet(object.open_order_cap)
          ? globalThis.Number(object.open_order_cap)
          : 0,
      openOrderCapSource: isSet(object.openOrderCapSource)
        ? openOrderCapSourceFromJSON(object.openOrderCapSource)
        : isSet(object.open_order_cap_source)
          ? openOrderCapSourceFromJSON(object.open_order_cap_source)
          : 0,
      perInstrumentTps: isSet(object.perInstrumentTps)
        ? globalThis.Number(object.perInstrumentTps)
        : isSet(object.per_instrument_tps)
          ? globalThis.Number(object.per_instrument_tps)
          : 0,
      perInstrumentBurst: isSet(object.perInstrumentBurst)
        ? globalThis.Number(object.perInstrumentBurst)
        : isSet(object.per_instrument_burst)
          ? globalThis.Number(object.per_instrument_burst)
          : 0,
      isMarketMakerTier: isSet(object.isMarketMakerTier)
        ? globalThis.Boolean(object.isMarketMakerTier)
        : isSet(object.is_market_maker_tier)
          ? globalThis.Boolean(object.is_market_maker_tier)
          : false,
      hasMarginSimulation: isSet(object.hasMarginSimulation)
        ? globalThis.Boolean(object.hasMarginSimulation)
        : isSet(object.has_margin_simulation)
          ? globalThis.Boolean(object.has_margin_simulation)
          : false,
      batchMax: isSet(object.batchMax)
        ? globalThis.Number(object.batchMax)
        : isSet(object.batch_max)
          ? globalThis.Number(object.batch_max)
          : 0,
      rateScopeKey: isSet(object.rateScopeKey)
        ? globalThis.String(object.rateScopeKey)
        : isSet(object.rate_scope_key)
          ? globalThis.String(object.rate_scope_key)
          : '',
      capScopeKey: isSet(object.capScopeKey)
        ? globalThis.String(object.capScopeKey)
        : isSet(object.cap_scope_key)
          ? globalThis.String(object.cap_scope_key)
          : '',
    }
  },

  toJSON(message: VenueCapabilities): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.venue !== 0) {
      obj.venue = tradeVenueToJSON(message.venue)
    }
    if (message.amendKeepsPriorityOnSizeDown !== false) {
      obj.amendKeepsPriorityOnSizeDown = message.amendKeepsPriorityOnSizeDown
    }
    if (message.hasInPlaceAmend !== false) {
      obj.hasInPlaceAmend = message.hasInPlaceAmend
    }
    if (message.hasCancelOnDisconnect !== false) {
      obj.hasCancelOnDisconnect = message.hasCancelOnDisconnect
    }
    if (message.hasDcp !== false) {
      obj.hasDcp = message.hasDcp
    }
    if (message.hasMmp !== false) {
      obj.hasMmp = message.hasMmp
    }
    if (message.mmpEnabled !== false) {
      obj.mmpEnabled = message.mmpEnabled
    }
    if (message.hasStp !== false) {
      obj.hasStp = message.hasStp
    }
    if (message.ownerTag !== 0) {
      obj.ownerTag = ownerTagKindToJSON(message.ownerTag)
    }
    if (message.maxOwnerTagLen !== 0) {
      obj.maxOwnerTagLen = Math.round(message.maxOwnerTagLen)
    }
    if (message.openOrderCap !== 0) {
      obj.openOrderCap = Math.round(message.openOrderCap)
    }
    if (message.openOrderCapSource !== 0) {
      obj.openOrderCapSource = openOrderCapSourceToJSON(message.openOrderCapSource)
    }
    if (message.perInstrumentTps !== 0) {
      obj.perInstrumentTps = Math.round(message.perInstrumentTps)
    }
    if (message.perInstrumentBurst !== 0) {
      obj.perInstrumentBurst = Math.round(message.perInstrumentBurst)
    }
    if (message.isMarketMakerTier !== false) {
      obj.isMarketMakerTier = message.isMarketMakerTier
    }
    if (message.hasMarginSimulation !== false) {
      obj.hasMarginSimulation = message.hasMarginSimulation
    }
    if (message.batchMax !== 0) {
      obj.batchMax = Math.round(message.batchMax)
    }
    if (message.rateScopeKey !== '') {
      obj.rateScopeKey = message.rateScopeKey
    }
    if (message.capScopeKey !== '') {
      obj.capScopeKey = message.capScopeKey
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VenueCapabilities>, I>>(base?: I): VenueCapabilities {
    return VenueCapabilities.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VenueCapabilities>, I>>(object: I): VenueCapabilities {
    const message = createBaseVenueCapabilities()
    message.accountId = object.accountId ?? ''
    message.venue = object.venue ?? 0
    message.amendKeepsPriorityOnSizeDown = object.amendKeepsPriorityOnSizeDown ?? false
    message.hasInPlaceAmend = object.hasInPlaceAmend ?? false
    message.hasCancelOnDisconnect = object.hasCancelOnDisconnect ?? false
    message.hasDcp = object.hasDcp ?? false
    message.hasMmp = object.hasMmp ?? false
    message.mmpEnabled = object.mmpEnabled ?? false
    message.hasStp = object.hasStp ?? false
    message.ownerTag = object.ownerTag ?? 0
    message.maxOwnerTagLen = object.maxOwnerTagLen ?? 0
    message.openOrderCap = object.openOrderCap ?? 0
    message.openOrderCapSource = object.openOrderCapSource ?? 0
    message.perInstrumentTps = object.perInstrumentTps ?? 0
    message.perInstrumentBurst = object.perInstrumentBurst ?? 0
    message.isMarketMakerTier = object.isMarketMakerTier ?? false
    message.hasMarginSimulation = object.hasMarginSimulation ?? false
    message.batchMax = object.batchMax ?? 0
    message.rateScopeKey = object.rateScopeKey ?? ''
    message.capScopeKey = object.capScopeKey ?? ''
    return message
  },
}

function createBaseMarginSimulated(): MarginSimulated {
  return {
    correlationId: '',
    initialMargin: undefined,
    maintenanceMargin: undefined,
    error: undefined,
  }
}

export const MarginSimulated: MessageFns<MarginSimulated> = {
  encode(message: MarginSimulated, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.correlationId !== '') {
      writer.uint32(10).string(message.correlationId)
    }
    if (message.initialMargin !== undefined) {
      writer.uint32(18).string(message.initialMargin)
    }
    if (message.maintenanceMargin !== undefined) {
      writer.uint32(26).string(message.maintenanceMargin)
    }
    if (message.error !== undefined) {
      writer.uint32(34).string(message.error)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MarginSimulated {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMarginSimulated()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.initialMargin = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.maintenanceMargin = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.error = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MarginSimulated {
    return {
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : '',
      initialMargin: isSet(object.initialMargin)
        ? globalThis.String(object.initialMargin)
        : isSet(object.initial_margin)
          ? globalThis.String(object.initial_margin)
          : undefined,
      maintenanceMargin: isSet(object.maintenanceMargin)
        ? globalThis.String(object.maintenanceMargin)
        : isSet(object.maintenance_margin)
          ? globalThis.String(object.maintenance_margin)
          : undefined,
      error: isSet(object.error) ? globalThis.String(object.error) : undefined,
    }
  },

  toJSON(message: MarginSimulated): unknown {
    const obj: any = {}
    if (message.correlationId !== '') {
      obj.correlationId = message.correlationId
    }
    if (message.initialMargin !== undefined) {
      obj.initialMargin = message.initialMargin
    }
    if (message.maintenanceMargin !== undefined) {
      obj.maintenanceMargin = message.maintenanceMargin
    }
    if (message.error !== undefined) {
      obj.error = message.error
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MarginSimulated>, I>>(base?: I): MarginSimulated {
    return MarginSimulated.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MarginSimulated>, I>>(object: I): MarginSimulated {
    const message = createBaseMarginSimulated()
    message.correlationId = object.correlationId ?? ''
    message.initialMargin = object.initialMargin ?? undefined
    message.maintenanceMargin = object.maintenanceMargin ?? undefined
    message.error = object.error ?? undefined
    return message
  },
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends globalThis.Array<infer U>
    ? globalThis.Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
      ? ReadonlyArray<DeepPartial<U>>
      : T extends {}
        ? { [K in keyof T]?: DeepPartial<T[K]> }
        : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never }

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter
  decode(input: BinaryReader | Uint8Array, length?: number): T
  fromJSON(object: any): T
  toJSON(message: T): unknown
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T
}
